angular.module('unica_wiki.wiki_services')

.factory('WikiDeleteService', function ($http, getBaseApiURL) {

	var wikiDeleteService = {};

	wikiDeleteService.delete = function (wikiId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/wiki/delete/' + wikiId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return wikiDeleteService;
});